<template>
  <!--begin::Dashboard-->
  <div class="p-5 container">
       <div class="mb-5 row">
      <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3"
          >หมวดหมู่</label
        >
        <el-select
          size="large"
          class="w-100"
          filterable
          v-model="filterForm.category"
          @change="searchData"
          placeholder="หมวดหมู่"
        >
          <el-option value="" label="ทั้งหมด"></el-option>
          <el-option
            v-for="ct in categoryList"
            :key="ct.categoryCode"
            :value="ct.categoryCode"
            :label="ct.categoryName[0].data"
          />
        </el-select>
      </div>
      <!-- <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3">สถานะ</label>
        <el-select
          size="large"
          class="w-100"
          filterable
          v-model="filterForm.status"
          @change="searchData"
          placeholder="สถานะ"
        >
          <el-option value="" label="ทั้งหมด"></el-option>
          <el-option value="-1" label="ยังไม่ได้ลงทะเบียน"></el-option>
          <el-option value="0" label="เรียนต่อ"></el-option>
         
          <el-option value="3" label="จบหลักสูตร"></el-option>
        </el-select>
      </div> -->
      <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3"
          >เรียงตาม</label
        >
        <el-select
          size="large"
          class="w-100"
          filterable
          v-model="filterForm.orderBy"
          @change="searchData"
          placeholder="เรียงตาม"
        >
          <el-option value="" label="ทั้งหมด"></el-option>
          <el-option value="3" label="ใหม่ล่าสุด"></el-option>
          <el-option value="1" label="แนะนำ"></el-option>
        </el-select>
      </div>
      <div class="col-12 col-lg mb-2">
        <label for="" class="text-category" style="color:#9999D3">ค้นหา</label>
        <input
          class="form-control"
          type="text"
          v-model="filterForm.search"
          @change="searchData"
          autocomplete="one-time-code"
           style="height:40px"
          
        />
      </div>
    </div>
    <div
      class="row mb-5"
      v-if="listData && listData.length > 0">
      <div
        class="col-12 col-lg-4 mb-5"
        v-for="(item, index) in listData"
        :key="index"
      >
            <div  @click="examOpen(item.id)"
              class="card box-item"
              style="border-radius: 10px;position: relative;border: 1px solid #F2E2E1;"
            >
              <img
                :src="imageUrl + item.thumbnailsPath"
                @error="setAltImg"
                alt=""
                class="w-100"
                style="border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            object-fit: cover;"
              />
              <div class="card-body responsive-body">
                <div
                  class="mb-5 limit-text text-title"
                  style="font-weight: 700;
                font-size: 20px;
                color: #323563;"
                >
                  {{ item.title }}
                </div>
                <p class="text-category" style="font-weight: 700;color:#DA595A">
                  รหัส : {{ item.examCode }}
                </p>
                <p class="text-category" style="color:#323563">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M11.668 10.9167H8.33464C8.11362 10.9167 7.90166 11.0045 7.74538 11.1607C7.5891 11.317 7.5013 11.529 7.5013 11.75C7.5013 11.971 7.5891 12.183 7.74538 12.3393C7.90166 12.4955 8.11362 12.5833 8.33464 12.5833H11.668C11.889 12.5833 12.1009 12.4955 12.2572 12.3393C12.4135 12.183 12.5013 11.971 12.5013 11.75C12.5013 11.529 12.4135 11.317 12.2572 11.1607C12.1009 11.0045 11.889 10.9167 11.668 10.9167ZM15.8346 5.08333H10.6013L10.3346 4.25C10.1618 3.76102 9.84109 3.33792 9.41705 3.0393C8.99301 2.74068 8.4866 2.58133 7.96797 2.58333H4.16797C3.50493 2.58333 2.86904 2.84672 2.4002 3.31556C1.93136 3.78441 1.66797 4.42029 1.66797 5.08333V15.9167C1.66797 16.5797 1.93136 17.2156 2.4002 17.6844C2.86904 18.1533 3.50493 18.4167 4.16797 18.4167H15.8346C16.4977 18.4167 17.1336 18.1533 17.6024 17.6844C18.0712 17.2156 18.3346 16.5797 18.3346 15.9167V7.58333C18.3346 6.92029 18.0712 6.28441 17.6024 5.81556C17.1336 5.34672 16.4977 5.08333 15.8346 5.08333ZM16.668 15.9167C16.668 16.1377 16.5802 16.3496 16.4239 16.5059C16.2676 16.6622 16.0556 16.75 15.8346 16.75H4.16797C3.94696 16.75 3.73499 16.6622 3.57871 16.5059C3.42243 16.3496 3.33464 16.1377 3.33464 15.9167V5.08333C3.33464 4.86232 3.42243 4.65036 3.57871 4.49408C3.73499 4.3378 3.94696 4.25 4.16797 4.25H7.96797C8.14267 4.24955 8.3131 4.30401 8.45516 4.4057C8.59722 4.50739 8.70373 4.65115 8.75964 4.81666L9.20964 6.18333C9.26554 6.34885 9.37205 6.49261 9.51411 6.5943C9.65617 6.69598 9.8266 6.75045 10.0013 6.75H15.8346C16.0556 6.75 16.2676 6.8378 16.4239 6.99408C16.5802 7.15036 16.668 7.36232 16.668 7.58333V15.9167Z"
                      fill="#9999D3"
                    />
                  </svg>
                  หมวดหมู่ :
                  {{
                    item.categoryProfile.length > 0
                      ? item.categoryProfile[0][0].data
                      : "-"
                  }}
                </p>
                <p class="text-category" style="color:#323563">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M17.6423 2.21669C17.045 2.1138 16.4401 2.06084 15.834 2.05835C13.7659 2.05666 11.741 2.64966 10.0006 3.76669C8.25576 2.66433 6.23118 2.08588 4.16731 2.10002C3.56118 2.1025 2.95631 2.15546 2.35897 2.25835C2.16331 2.29209 1.98612 2.39457 1.85932 2.54735C1.73251 2.70013 1.66442 2.89316 1.66731 3.09169V13.0917C1.66552 13.2141 1.69075 13.3355 1.74118 13.4471C1.79162 13.5586 1.86603 13.6577 1.95912 13.7373C2.05221 13.8169 2.16169 13.8749 2.27977 13.9074C2.39785 13.9398 2.52163 13.9458 2.64231 13.925C3.83649 13.7183 5.05998 13.7526 6.2407 14.0259C7.42142 14.2993 8.53549 14.8061 9.51731 15.5167L9.61731 15.575H9.70897C9.80139 15.6135 9.90052 15.6334 10.0006 15.6334C10.1008 15.6334 10.1999 15.6135 10.2923 15.575H10.384L10.484 15.5167C11.4589 14.7903 12.5698 14.267 13.7508 13.9778C14.9317 13.6887 16.1587 13.6395 17.359 13.8334C17.4796 13.8542 17.6034 13.8482 17.7215 13.8157C17.8396 13.7833 17.9491 13.7252 18.0422 13.6456C18.1353 13.5661 18.2097 13.467 18.2601 13.3554C18.3105 13.2438 18.3358 13.1225 18.334 13V3.00002C18.3253 2.81015 18.252 2.62895 18.1262 2.48647C18.0004 2.34399 17.8296 2.2488 17.6423 2.21669ZM9.16731 13.2917C7.62554 12.4806 5.90941 12.0573 4.16731 12.0584C3.89231 12.0584 3.61731 12.0584 3.33397 12.0584V3.72502C3.61152 3.70902 3.88976 3.70902 4.16731 3.72502C5.94513 3.72305 7.68415 4.24476 9.16731 5.22502V13.2917ZM16.6673 12.0917C16.384 12.0917 16.109 12.0917 15.834 12.0917C14.0919 12.0906 12.3757 12.5139 10.834 13.325V5.22502C12.3171 4.24476 14.0562 3.72305 15.834 3.72502C16.1115 3.70902 16.3898 3.70902 16.6673 3.72502V12.0917ZM17.6423 15.55C17.045 15.4471 16.4401 15.3942 15.834 15.3917C13.7659 15.39 11.741 15.983 10.0006 17.1C8.26024 15.983 6.23534 15.39 4.16731 15.3917C3.56118 15.3942 2.95631 15.4471 2.35897 15.55C2.2505 15.5672 2.14649 15.6057 2.05294 15.6633C1.95939 15.7208 1.87814 15.7963 1.81386 15.8854C1.74958 15.9744 1.70354 16.0753 1.67839 16.1822C1.65324 16.2891 1.64947 16.4 1.66731 16.5084C1.70966 16.7248 1.83605 16.9156 2.0188 17.0389C2.20155 17.1623 2.42576 17.2083 2.64231 17.1667C3.83649 16.9599 5.05998 16.9942 6.2407 17.2676C7.42142 17.5409 8.53549 18.0478 9.51731 18.7584C9.65844 18.8588 9.82739 18.9128 10.0006 18.9128C10.1739 18.9128 10.3428 18.8588 10.484 18.7584C11.4658 18.0478 12.5799 17.5409 13.7606 17.2676C14.9413 16.9942 16.1648 16.9599 17.359 17.1667C17.5755 17.2083 17.7997 17.1623 17.9825 17.0389C18.1652 16.9156 18.2916 16.7248 18.334 16.5084C18.3518 16.4 18.348 16.2891 18.3229 16.1822C18.2977 16.0753 18.2517 15.9744 18.1874 15.8854C18.1231 15.7963 18.0419 15.7208 17.9483 15.6633C17.8548 15.6057 17.7508 15.5672 17.6423 15.55Z"
                      fill="#9999D3"
                    />
                  </svg>
                  จำนวนข้อสอบ : {{ item.totalQuestion }} ข้อ
                </p>
                <p class="text-category" style="color:#323563">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M16.6654 7.94996C16.6567 7.8734 16.6399 7.79799 16.6154 7.72496V7.64996C16.5753 7.56428 16.5219 7.48551 16.457 7.41663L11.457 2.41663C11.3881 2.35181 11.3094 2.29836 11.2237 2.25829C11.1988 2.25476 11.1736 2.25476 11.1487 2.25829C11.064 2.20974 10.9706 2.17858 10.8737 2.16663H5.83203C5.16899 2.16663 4.53311 2.43002 4.06426 2.89886C3.59542 3.3677 3.33203 4.00358 3.33203 4.66663V16.3333C3.33203 16.9963 3.59542 17.6322 4.06426 18.1011C4.53311 18.5699 5.16899 18.8333 5.83203 18.8333H14.1654C14.8284 18.8333 15.4643 18.5699 15.9331 18.1011C16.402 17.6322 16.6654 16.9963 16.6654 16.3333V7.99996C16.6654 7.99996 16.6654 7.99996 16.6654 7.94996ZM11.6654 5.00829L13.8237 7.16663H12.4987C12.2777 7.16663 12.0657 7.07883 11.9094 6.92255C11.7532 6.76627 11.6654 6.55431 11.6654 6.33329V5.00829ZM14.9987 16.3333C14.9987 16.5543 14.9109 16.7663 14.7546 16.9225C14.5983 17.0788 14.3864 17.1666 14.1654 17.1666H5.83203C5.61102 17.1666 5.39906 17.0788 5.24278 16.9225C5.0865 16.7663 4.9987 16.5543 4.9987 16.3333V4.66663C4.9987 4.44561 5.0865 4.23365 5.24278 4.07737C5.39906 3.92109 5.61102 3.83329 5.83203 3.83329H9.9987V6.33329C9.9987 6.99633 10.2621 7.63222 10.7309 8.10106C11.1998 8.5699 11.8357 8.83329 12.4987 8.83329H14.9987V16.3333ZM11.907 10.7416L9.16536 13.4916L8.09036 12.4083C7.93344 12.2514 7.72062 12.1632 7.4987 12.1632C7.27678 12.1632 7.06395 12.2514 6.90703 12.4083C6.75011 12.5652 6.66195 12.778 6.66195 13C6.66195 13.2219 6.75011 13.4347 6.90703 13.5916L8.5737 15.2583C8.65117 15.3364 8.74333 15.3984 8.84488 15.4407C8.94643 15.483 9.05535 15.5048 9.16536 15.5048C9.27537 15.5048 9.3843 15.483 9.48585 15.4407C9.58739 15.3984 9.67956 15.3364 9.75703 15.2583L13.0904 11.925C13.2473 11.768 13.3354 11.5552 13.3354 11.3333C13.3354 11.1114 13.2473 10.8985 13.0904 10.7416C12.9334 10.5847 12.7206 10.4966 12.4987 10.4966C12.2768 10.4966 12.064 10.5847 11.907 10.7416Z"
                      fill="#9999D3"
                    />
                  </svg>
                  คะแนนเต็ม : {{ item.totalScore }} คะแนน
                </p>
              </div>
            </div>
      </div>
    </div>
    <div class=" row mb-5" v-else>
      <img src="media/image-app/no-data.svg" alt="" style="height:300px" />
    </div>
    <ul class="pagination" v-if="listData && listData.length > 0">
      <li :class="'page-item previous ' + (page == 0 ? 'disabled' : '')">
        <button type="button" @click="backPage()" class="page-link">
          <i class="previous"></i>
        </button>
      </li>
      <div v-for="(item, index) in totalPage" :key="index">
        <li :class="'page-item ' + (index == page ? 'active' : '')">
          <button type="button" @click="changePage(item)" class="page-link">
            {{ item }}
          </button>
        </li>
      </div>
      <li
        :class="'page-item next ' + (page + 1 == totalPage ? 'disabled' : '')"
      >
        <button type="button" @click="nextPage()" class="page-link">
          <i class="next"></i>
        </button>
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import axios from "axios";
const video = ref();
const canvas = ref();
const captures = ref({});
const isCameraOpen = ref(false);
const listData = ref();
const limit = ref(6);
const page = ref(0);
const orderBy = ref(2);
const sortBy = ref(1);
const categories = ref([]);
const totalPage = ref(0);
const filterForm = ref({
  category: "",
  status: "",
  orderBy: "3",
  search: ""
});

export default defineComponent({
  name: "exam-general",
  components: {},
  data() {
    return {
      categoryList: [],
      imageUrl: process.env.VUE_APP_IMG_URL,
    };
  },
  setup() {
    onMounted(() => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      getDataList();
    });
    const getDataList = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getExam?sizeContents=" +
            limit.value +
            "&page=" +
            page.value +
            "&orderBy=" +
            orderBy.value +
            "&sort=" +
            filterForm.value.orderBy +
            "&category=" +
            filterForm.value.category +
            "&status=2"  +
             "&keyWord=" +
             filterForm.value.search+
             "&examType=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
            },
          }
        )
        .then((response) => {
          console.log("getExam");
          console.log(response.data.data.content);
          listData.value = response.data.data.content;
          listData.value["totalElements"] = response.data.data.totalElements;
          totalPage.value = response.data.data.totalPages;
          setCurrentPageBreadcrumbs( "แบบฝึกหัด", []);
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const changePage = (pageEvent) => {
      // console.log(pageEvent);
      page.value = pageEvent - 1;
      getDataList();
    };
    const backPage = () => {
      page.value = page.value - 1;
      getDataList();
    };
    const nextPage = () => {
      page.value = page.value + 1;
      getDataList();
    };
    const searchData = () => {
      getDataList();
    };
    return {
      video,
      canvas,
      captures,
      isCameraOpen,
      getDataList,
      changePage,
      backPage,
      nextPage,
      listData,
      limit,
      page,
      orderBy,
      sortBy,
      categories,
      totalPage,
      filterForm,
      searchData,
    };
  },
  methods: {
    removeStyle(html) {
      const regex = /(style=".+?")/gm;
      const str = html;
      const subst = ``;
      const result = str.replace(regex, subst);
      return result;
    },
    setAltImg(event) {
      event.target.src = "media/image-app/no-image.svg";
    },
    /* eslint-disable */
    renderCategory(list) {
      let data: any = [];
      for (const looplist of list) {
        data.push(looplist[0].data);
      }
      if (data.length > 0) {
        return data.join(",");
      } else {
        return "-";
      }
    },
    renderStatus(status) {
      if (status == 1 || status == 2) {
        return "<span style='color:#FFE454'>เรียนต่อ</span>";
      } else if (status == 3) {
        return "<span style='color:#42FB91'>จบหลักสูตร</span>";
      } else if (status == 4) {
        return "<span style='color:#F998A2'>ไม่ผ่านหลักสูตร</span>";
      } else if (status == 5) {
        return "<span style='color:#ECAE51'>หมดเวลาเรียน</span>";
      } else {
        return "-";
      }
    },
    examOpen(id) {
      if (localStorage.getItem("id_token") != null) {
        this.$router.push({ name: "exam-general-detail", params: { id: id } });
      } else {
        this.$router.push({ name: "sign-in"});
      }
    },
  },
  async mounted() {
    const category = await axios.get(
      process.env.VUE_APP_API_URL + "/category?categoryType=exam",
      { headers: {
        token: localStorage.getItem("id_token")
            ? localStorage.getItem("id_token")
            : localStorage.getItem("tokenGuest"),
      } }
    );
    console.log("category" ,  category.data.data);
    this.categoryList = category.data.data;
  },
  
});
</script>
<style>
.el-input__inner {
  background: var(--e-9-e-9-ef, #e9e9ef);
  border: 0px;
  border-radius: 10px;
}
</style>

